import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { PhoneInput } from 'react-international-phone';

const CustomerInfos = ({ formData, handleFormChange, formError }) => {
  const onPhoneChange = (phone, _country, _inputValue) => {
    // TODO: enhance this to update number with country code
    handleFormChange({ key: 'phone', value: phone });
  };
  console.log(formData);
  return (
    <Box sx={{ width: '100%', mt: 3 }}>
      <Typography
        color="primary"
        sx={{ fontSize: '1em', fontWeight: 'bold', mb: 1 }}
      >
        Informations client
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="Nom"
            value={formData.lastName}
            error={Boolean(formError.lastName)}
            helperText={formError.lastName}
            onChange={(e) =>
              handleFormChange({ key: 'lastName', value: e.target.value })
            }
            fullWidth
            size="small"
          />
          <TextField
            label="Prénom"
            value={formData.firstName || ''}
            error={Boolean(formError.firstName)}
            helperText={formError.firstName}
            onChange={(e) =>
              handleFormChange({ key: 'firstName', value: e.target.value })
            }
            fullWidth
            size="small"
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
          <Typography variant="caption" sx={{ ml: 1 }}>
            Téléphone
          </Typography>
          <PhoneInput
            value={formData?.phone || '+33'}
            defaultCountry={
              formData?.phone || formData?.billingAddress?.country
            }
            onChange={(phone, { country, inputValue }) =>
              onPhoneChange(phone, country, inputValue)
            }
            fullWidth
          />
          {Boolean(formError.phone) && (
            <Typography variant="caption" sx={{ ml: 1, color: '#B11A06' }}>
              {formError?.phone}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerInfos;
